import styled from "styled-components";

export const Label = styled.label`
  display: inline-block;
  color: #9074bf;
  font-size: 14px;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 8px;

  &.error {
    color: #d44c4c;
  }
`;
